import api from "../../config/APIConfig";
const { iAxios, apiUri } = api;
const baseUrl = `${apiUri}`;

function validaCodigo(codigoFujo, correo, codigo) {
  return iAxios.get(
    `${baseUrl}/FAO/validaCodigo?codigoFujo=` +
      codigoFujo +
      "&correo=" +
      correo +
      "&codigo=" +
      codigo,
    { headers: { sitePath: document.URL } }
  );
}
function credenciales(objDesc) {
  return iAxios.post(`${baseUrl}/FAO/credenciales`, objDesc, {
    responseType: "blob",
  });
}

const centralizarCertificado = (params) =>
  iAxios.post(`${baseUrl}/FES/centralize`, params).then((value) => value?.data);

export const CertificadoActions = {
  validaCodigo,
  credenciales,
  centralizarCertificado,
};
